import { RouteObject } from 'react-router';

const ticketScannenRoutes: RouteObject[] = [
  {
    path: 'ticket-scannen',
    lazy: () => import('./page/ticket-scannen-page.tsx'),
  },
];

export default ticketScannenRoutes;
